/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_Clients_UpdatedInputs */

const cs_import_stat_clients_updated = /** @type {(inputs: Import_Stat_Clients_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Klienti aktualizováni: ${i?.count}`)
};

const en_import_stat_clients_updated = /** @type {(inputs: Import_Stat_Clients_UpdatedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Clients updated: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Clients updated: {count}" |
*
* @param {Import_Stat_Clients_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_clients_updated = /** @type {((inputs: Import_Stat_Clients_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_Clients_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_clients_updated(inputs)
	return cs_import_stat_clients_updated(inputs)
});